import { HeaderCall2Action, HeaderCompanyHours, Paragraph } from "./HomePageHeader";
import { Button } from "assets/styles/Elements/Button.styled";
import data from "assets/data/data.json";

interface CompanyHours {
  dag: string;
  tijd: string;
}

function HomePage() {
  function companyHours() {
    let companyHours: any;
    data.routes.map((route) => (route.path === "/") ? companyHours = route.content : null);
    return companyHours.openingstijden;
  }

  return (
    <>
      <HeaderCall2Action>
        <h1>Zorg met Liefde <span>vanuit het Hart</span></h1>
        <Paragraph>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis ullam molestiae ducimus reiciendis alias possimus corporis ut, enim aspernatur fuga eum harum? Sunt et aliquam dolores vero dolorem obcaecati cumque quidem! Ipsam totam non suscipit, quidem quaerat soluta, quibusdam explicabo voluptatum at animi culpa reprehenderit. Tenetur est explicabo quas? Maiores!
        </Paragraph>
        <Button>Onze Diensten</Button>
      </HeaderCall2Action>

      <HeaderCompanyHours>
        <h3>Noer Care B.V.</h3>
        <hr />
        <Paragraph>
          Lorem, ipsum dolor sit amet lorem, ipsum dolor sit amet. Lorem ipsum.
          {companyHours().map((item: CompanyHours, idx: number) => <span key={idx}><span>{item.dag}</span><span>{item.tijd}</span></span>)}
        </Paragraph>
      </HeaderCompanyHours>
    </>
  )
}

export default HomePage
